import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import { queryKeys } from '@/lib/queryClient';

export interface PreviewTrack {
  videoId: string;
  title: string;
  thumbnailUrl?: string;
  publishedAt: string;
  durationSeconds: number;
}

export interface ChannelPreviewData {
  channelId: string;
  videos: PreviewTrack[];
}

export function useChannelPreview(channelId: string, enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.channelPreview(channelId),
    queryFn: async (): Promise<ChannelPreviewData> => {
      const response = await api.get<ChannelPreviewData>(`/youtube/channels/${channelId}/preview`);
      return response.data as ChannelPreviewData;
    },
    enabled,
    staleTime: 6 * 60 * 60 * 1000,
  });
}
